import React, { PureComponent } from "react";

import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { setRole } from "redux/ducks/Registration";
import AthleticTrainer from "./AthleticTrainer";
import RegisteredNurse from "./RegisteredNurse";
import {
  registrationFieldUpdate,
} from "redux/ducks/Registration";

export class Role extends PureComponent {
  componentDidMount() {
    this.updateRole();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.updateRole();
    }
  }

  updateRole() {
    const { role, setRole, match, location } = this.props;
    if (location.pathname.includes("athletic-trainer"))
      setRole("AthleticTrainer");
    if (match.isExact && role) setRole(undefined);
  }

  onSelectRole(role) {
    this.props.setRole(role);
  }

  handleEOClick = () => {
    this.props.history.push("/sign-up/post-event/account");
  };

  handleATClick = () => {
    this.props.setRole("AthleticTrainer");
    this.props.history.push("/sign-up/role/athletic-trainer");
  };

  handleRNClick = () => {
    this.props.setRole("RegisteredNurse");
    this.props.history.push("/sign-up/role/registered-nurse");
  };

  handleLongTermClick = (e) => {
    e.preventDefault();
    this.props.updateField("postEventMasterType", "contract");
    this.props.history.push("/sign-up/post-event/profile")
  }

  render() {
    return (
      <div className="role">
        <div className="content">
          <div className="logo">
            <img src={require("logo-4.svg")} alt="4" />
          </div>
          <div className="options">
            {!this.props.role && (
              <div className="select-role">
                <h2>Healthcare Providers<br />On-Demand</h2>
                <div>
                  <hr />
                  <button
                    className="btn btn-primary bold-button"
                    onClick={this.handleEOClick}
                  >
                    Post a job
                  </button>
                  <a
                    className="btn btn-primary bold-button"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://go4.io/athletic-trainers"
                  >
                    Work a Job / athletic trainer
                  </a>
                  <a
                    className="btn btn-primary bold-button"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://go4.io/nurses"
                  >
                    Work a Job / registered nurse
                  </a>
                  <button
                    className="btn btn-primary bold-button"
                    onClick={this.handleLongTermClick}
                  >
                    Long-Term Contract
                  </button>
                </div>
              </div>
            )}

            <Route path={`${this.props.match.url}/athletic-trainer`}>
              <AthleticTrainer />
            </Route>
            <Route path={`${this.props.match.url}/registered-nurse`}>
              <RegisteredNurse />
            </Route>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.registration.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setRole: role => dispatch(setRole(role)),
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Role);
